import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { ThreeLinePreviewSkeleton } from './ThreeLinePreviewSkeleton';
export function PayoutPreviewSkeleton(props) {
    return /*#__PURE__*/ _jsx(ThreeLinePreviewSkeleton, _object_spread_props(_object_spread({}, props), {
        lineCount: 2
    }));
}
